
import React, { useState } from 'react';
import './MeusPedidos.css';
import useOrderData from "../../../hooks/useOrderData";
import { parseISO, format } from 'date-fns';
import Payment from '../../checkout/pagamento/Pagamento';

const OrderList = ({ user }) => {

  const formatDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'dd/MM/yyyy');
  };
  const { orders, loading, error } = useOrderData(user);
  const [showDetails, setShowDetails] = useState({});
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedQrCode, setSelectedQrCode] = useState(null);

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Ocorreu um erro: {error}</p>;

  const toggleDetails = (orderId) => {
    setShowDetails(prevState => ({
      ...prevState,
      [orderId]: !prevState[orderId]
    }));
  };

  const handlePaymentClick = (qrCode) => {
    setSelectedQrCode(qrCode);
    setShowPaymentModal(true);
  };

  const closeModal = () => {
    setShowPaymentModal(false);
    setSelectedQrCode(null);
  };

  return (
    <div>
      <h2>Lista de Pedidos</h2>
      <div className='lista-de-pedidos-container'>
        {orders.map((order) => (
          <div key={order.id} className='lista-de-pedidos-item'>
            <div className='pedidos-header'>
              <strong>
                <p>N. Pedido: {order.id}</p>
              </strong>
              <p>{order.data}</p>
            </div>
            <p>Valor Total: <strong>R${(order.valorTotal / 100).toFixed(2)}</strong></p>
            <p>Status: {order.status}</p>
            <div className='pedidos-bottom'>
              <button onClick={() => toggleDetails(order.id)}>
                {showDetails[order.id] ? 'Esconder Detalhes' : 'Mostrar Detalhes'}
              </button>
              {order.status === 'Pagamento pendente' && (
                <button className='pagar-btn' onClick={() => handlePaymentClick(order.qr_code)}>
                  Realizar Pagamento
                </button>
              )}
            </div>
            {showDetails[order.id] && (
              <div className="pedido-detalhes">

                <p><strong>Data da compra</strong> </p>
                <p>{formatDate(order.created_at)}</p>
                <span><strong>Livros </strong></span>
                  {order.livros.map((livro) => (
                    <p key={livro.id}>
                      {livro.titulo} - R${livro.preco}
                    </p>
                  ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {showPaymentModal && (
        <div className='modal-overlay'>
          <div className='modal-content'>
            <Payment qrCode={selectedQrCode} orderList={true} />
            <button className='close-modal' onClick={closeModal}>X</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderList;